import { render, staticRenderFns } from "./ColumnChart.vue?vue&type=template&id=5f65e20a"
import script from "./ColumnChart.vue?vue&type=script&lang=js"
export * from "./ColumnChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports